// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1PIHP","info":"Note_info__2YmFU","note":"Note_note__1Xz8s","actions":"Note_actions__2ICTF"};